import { makeAutoObservable } from 'mobx';

import { SetupPresetType } from '@/media/entity/SetupPreset';
import { ALL_PRODUCT_TYPES } from '@/product/constants/productTypes';

import SetupPresetGroup, { SetupPresetGroupModel, SetupPresetGroupType } from '../entity/SetupPresetGroup';

import { setupPresetRepository } from './SetupPresetRepository';

class SetupPresetGroupRepository {
  setupPresetGroups: SetupPresetGroup[] = [];

  spgIdsMapSortedByProductType: Record<string, number[]> = {};

  spgsMapSortedByProductType: Record<string, SetupPresetGroup[]> = {};

  constructor() {
    makeAutoObservable(this, {
      spgIdsMapSortedByProductType: false,
      spgsMapSortedByProductType: false,
    });
  }

  initSetupPresetGroups(setupPresetGroups: SetupPresetGroupModel[]) {
    this.setupPresetGroups = setupPresetGroups
      .sort((a, b) => (a.position > b.position ? 1 : -1))
      .map(
        (spg) => new SetupPresetGroup({
          ...spg,
          sp: spg.sp.map((id) => setupPresetRepository.findSetupPresetById(id)),
        }),
      );
  }

  initSorts(sorts: Record<string, { spgList: number[] }>) {
    ALL_PRODUCT_TYPES.forEach((productType) => {
      if (sorts[productType]) {
        this.spgIdsMapSortedByProductType[productType] = sorts[productType].spgList;
      }
    });
  }

  getSortedSpgsByProductType(productType: string) {
    if (!Object.keys(this.spgsMapSortedByProductType).includes(productType)) {
      if (this.spgIdsMapSortedByProductType[productType]) {
        this.spgsMapSortedByProductType[productType] = this.spgIdsMapSortedByProductType[productType]
          .map((spgId) => this.findSetupPresetGroupById(spgId))
          .filter((spg) => Boolean(spg)) as SetupPresetGroup[];
      }
    }

    return this.spgsMapSortedByProductType[productType];
  }

  findSetupPresetGroupById(id: SetupPresetGroupType) {
    if (!this.setupPresetGroups || this.setupPresetGroups.length === 0) {
      return null;
    }

    return this.setupPresetGroups.find((spg) => spg.id === id) ?? null;
  }

  findSetupPresetGroupBySetupPresetId(id: SetupPresetType) {
    if (!this.setupPresetGroups || this.setupPresetGroups.length === 0) {
      return null;
    }

    const setupPresetGroups: SetupPresetGroup[] = [];

    this.setupPresetGroups.forEach((spg) => {
      spg.sp.forEach((sp) => {
        if (sp?.id === id) {
          setupPresetGroups.push(spg);
        }
      });
    });

    return setupPresetGroups;
  }
}

export const setupPresetGroupRepository = new SetupPresetGroupRepository();
